var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAmexBgMinimized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 52 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0572ce",
    d: "M47.736-20.131h-2.283v-1.15h1.992s.726.084.726-.4c0-.45-1.086-.415-1.086-.415s-1.77.152-1.77-1.487a1.474 1.474 0 011.6-1.538h2.455v1.166h-1.976s-.684-.136-.684.356c0 .412.932.353.932.353s1.958-.137 1.958 1.366a1.6 1.6 0 01-1.709 1.755c-.1 0-.155-.006-.155-.006zm-11.389.008v-4.984h4v1.157h-2.71v.768h2.643v1.133h-2.643v.846h2.711v1.08zm6.866-.008h-2.284v-1.15h2s.718.084.718-.4c0-.45-1.086-.415-1.086-.415s-1.77.152-1.77-1.487a1.474 1.474 0 011.6-1.538h2.464v1.166h-1.984s-.685-.136-.685.356c0 .412.931.353.931.353s1.959-.143 1.959 1.361a1.6 1.6 0 01-1.709 1.755c-.1 0-.155-.006-.155-.006zm-17.3.009h-1.12L23.434-21.6l-1.368 1.479H17.3v-5h4.669l1.471 1.588 1.479-1.579h.981v-.009h3.11a1.413 1.413 0 011.625 1.469c0 1.47-.54 1.927-2.2 1.927H27.18v1.605zm-1.606-2.458l1.593 1.74v-3.472l-1.593 1.732zm-5.721 1.38h2.7l1.266-1.376-1.266-1.369h-2.7v.768h2.634v1.133h-2.634v.845zm8.594-1.826h1.325c.385 0 .7-.211.7-.473s-.316-.473-.7-.473H27.18v.946zm7.286 2.915v-.972a.824.824 0 00-.856-.76h-1.248v1.732h-1.284v-4.992h3.113a1.4 1.4 0 011.624 1.461 1.274 1.274 0 01-.715 1.162 1.223 1.223 0 01.616 1.131v1.234zm-2.1-2.906h1.325c.385 0 .7-.211.7-.473s-.316-.473-.7-.473h-1.329v.946zm-.966-3.931h1.29v-5.009H31.4zm-9.936-.017v-4.992h4v1.165H22.75v.769h2.642v1.132H22.75v.846h2.711v1.08zm-2.01 0v-3.447l-1.607 3.447H16.79l-1.616-3.43v3.43h-2.531l-.443-1.047H9.856L9.4-26.965H8l2.129-4.993h1.8l1.95 4.587v-4.587h2.031l1.411 3.1 1.4-3.1h2.027v4.993zM10.4-29.288h1.248l-.624-1.486zm34.246 2.323L42.615-30.3v3.337H40.1l-.453-1.047H37.3l-.445 1.047h-2.01a2.174 2.174 0 01-1.726-2.357c0-2.771 1.958-2.661 2.026-2.678l1.582.042v1.124l-1.3.017s-.847 0-.951 1.09c-.011.126-.017.24-.016.347A1.073 1.073 0 0036-28.232l1.59-3.725h1.795l1.924 4.528v-4.528h1.813l2.01 3.286v-3.286h1.288v4.993zm-6.8-2.323H39.1l-.616-1.486-.633 1.486zm-8.338 2.323v-.972a.821.821 0 00-.855-.76h-1.242v1.732h-1.283v-4.993h3.112a1.4 1.4 0 011.625 1.458 1.274 1.274 0 01-.718 1.166 1.222 1.222 0 01.624 1.132v1.234zm-2.1-2.906h1.325c.385 0 .7-.211.7-.473s-.316-.473-.7-.473h-1.322z",
    clipRule: "evenodd",
    transform: "translate(-8 32)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-197-19.571h343.943V-157H-197z",
    className: "b",
    transform: "translate(197 157)"
  })), /*#__PURE__*/React.createElement("style", null, "\n      .amex-blue {\n        fill: #0572ce\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff",
    stroke: "#e9e9e9",
    strokeMiterlimit: 10,
    strokeWidth: 0.533
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 32,
    stroke: "none",
    rx: 2.133
  }), /*#__PURE__*/React.createElement("rect", {
    width: 51.467,
    height: 31.467,
    x: 0.267,
    y: 0.267,
    fill: "none",
    rx: 1.867
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "translate(4.943 10.372)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)",
    transform: "translate(-152.286 -92.857)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M148.571 89.143h49.028v19.314h-49.028z",
    className: "amex-blue"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmexBgMinimized);
export default __webpack_public_path__ + "static/media/amex-bg-minimized.a4e6a0cb.svg";
export { ForwardRef as ReactComponent };